import { Navigate, Route, Routes } from 'react-router-dom';
import { SupportAuthProvider } from '@/context/SupportAuthContext';
import { RequireAgent } from '@/components/support/RequireAgent';
import { SupportShell } from '@/components/support/SupportShell';
import {
  AdminSupportPage,
  ChatHistoryPage,
  SupportDashboardPage,
  SupportLandingPage,
  SupportLoginPage,
} from '@/pages/support';

export function SupportApp() {
  return (
    <SupportAuthProvider>
      <Routes>
        <Route path="login" element={<SupportLoginPage />} />
        <Route path="request/:requestId" element={<SupportLandingPage />} />
        <Route
          element={
            <RequireAgent>
              <SupportShell />
            </RequireAgent>
          }
        >
          <Route path="dashboard" element={<SupportDashboardPage />} />
          <Route path="history" element={<ChatHistoryPage />} />
          <Route
            path="admin"
            element={
              <RequireAgent adminOnly>
                <AdminSupportPage />
              </RequireAgent>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/support/dashboard" replace />} />
      </Routes>
    </SupportAuthProvider>
  );
}
